module.exports = __webpack_public_path__ + "img/ALL.ed23ad80.png";